import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-notecriterias',
  templateUrl: './delete-notecriterias.component.html',
  styleUrls: ['./delete-notecriterias.component.scss']
})
export class DeleteNotecriteriasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
